/**
 * Expanded workshop catalogue — filled by workshop-a / workshop-b modules.
 */

import type { LevelData } from '../game/types'
import { WORKSHOP_A_COURSES, WORKSHOP_A_LIST } from './workshop-a'
import { WORKSHOP_B_COURSES, WORKSHOP_B_LIST } from './workshop-b'

/** Extra built-ins keyed by name. */
export const WORKSHOP_COURSES: Record<string, LevelData> = {
  ...WORKSHOP_A_COURSES,
  ...WORKSHOP_B_COURSES,
}

/** Extra built-ins in play order (after the five classics). */
export const WORKSHOP_LIST: LevelData[] = [
  ...WORKSHOP_A_LIST,
  ...WORKSHOP_B_LIST,
]
